module.exports = __webpack_public_path__ + "3c04c864fc7353d9e3a34e65f0fa2770.pdf";